import Vue from 'vue'
import Router from 'vue-router'
import Home from './components/Home.vue'
import Login from './components/Login.vue'
import Register from "./components/Register";
import AdminHome from './components/administration/AdminHome';

Vue.use(Router);

import store from './store';

const beforeEnter = (to, from, next) => {
  if (store.state.authModule.logged) {
    next({path: '/'});
  } else {
    next();
  }
};

const router =  new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: { Auth: false, title: 'Inicio'},
      beforeEnter: (to, from, next) => beforeEnter(to, from, next)
    }, {
      path: '/register',
      name: 'Register',
      component: Register,
      meta: { Auth: false, title: 'Registro'},
      beforeEnter: (to, from, next) => beforeEnter(to, from, next)
    }, {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { Auth: false, title: 'Iniciar sesion'},
      beforeEnter: (to, from, next) => beforeEnter(to, from, next)
    }, {
      path: '/admin',
      name: 'Admin',
      component: AdminHome,
      meta: { Auth: true, title: 'Administracion', role: 'admin'},
      beforeEnter: (to, from, next) => beforeEnter(to, from, next),
      children: [

      ]
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './components/About.vue')
    }
  ]
});

router.beforeEach((to, from, next) => {
  document.title = "Colegio Herbart - " + to.meta.title;
  if (to.meta.Auth && !store.state.authModule.logged && store.state.loaded) {
    next({path: '/login'});
  } else {
    if (to.meta.role) {
      if (store.state.loaded && (to.meta.role !== store.state.authModule.role)) {
        next({path: '/'});
        return;
      }
    }
    next();
  }
});

export default router;
